import React, { useRef, useState } from 'react';
import { fotosStudio } from '../data/studio';
export function StudioGallery() {
  const trilhoRef = useRef<HTMLUListElement>(null);
  const [ativo, setAtivo] = useState(0);
  const onScroll = () => {
    const trilho = trilhoRef.current;
    if (!trilho) return;
    const itens = Array.from(trilho.children) as HTMLElement[];
    if (itens.length < 2) return;
    const passo = itens[1].offsetLeft - itens[0].offsetLeft;
    if (passo <= 0) return;
    setAtivo(Math.min(itens.length - 1, Math.max(0, Math.round(trilho.scrollLeft / passo))));
  };
  const irPara = (indice: number) => {
    const trilho = trilhoRef.current;
    if (!trilho) return;
    const item = trilho.children[indice] as HTMLElement | undefined;
    if (!item) return;
    trilho.scrollTo({
      left: item.offsetLeft - trilho.offsetLeft,
      behavior: 'smooth'
    });
  };
  return <div data-id="element-168" data-mp="1ipg3hirzk9ub">
      <ul ref={trilhoRef} onScroll={onScroll} className="no-scrollbar -mx-4 flex snap-x snap-mandatory scroll-px-4 gap-4 overflow-x-auto px-4" data-id="element-169" data-mp="1ip6he6a2amtw">
        {fotosStudio.map(foto => <li key={foto.id} className="w-[68%] shrink-0 snap-start" data-id="element-170" data-mp="xruj30idwx6k">
            <figure className="flex h-full flex-col overflow-hidden rounded-2xl border border-shell bg-white/60" data-id="element-171" data-mp="xu7ae4a18jwa">
              <img src={foto.imagem} alt={foto.alt} draggable={false} className="h-56 w-full object-cover" data-id="element-172" data-mp="o2axhn3aep80" />
              <figcaption className="flex min-h-[52px] items-center px-4 py-3 text-[12.5px] leading-snug text-muted" data-id="element-173" data-mp="1bpsxu70mavml">
                {foto.legenda}
              </figcaption>
            </figure>
          </li>)}
      </ul>

      <div className="mt-4 flex items-center justify-center gap-1.5" data-id="element-174" data-mp="16s9guzcjc4qy">
        {fotosStudio.map((foto, indice) => <button key={foto.id} type="button" onClick={() => irPara(indice)} aria-label={`Ver foto ${indice + 1}: ${foto.legenda}`} aria-current={indice === ativo} className={`h-1.5 rounded-full transition-[width,background-color] duration-200 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-mocha ${indice === ativo ? 'w-5 bg-mocha' : 'w-1.5 bg-shell hover:bg-mocha/40'}`} data-id="element-175" data-mp="3ngda92mn23xu" data-mpi={indice} />)}
      </div>
    </div>;
}